import { useState } from "react";

import DstButton from "../../../../../components/DstButton/DstButton";
import MultiSelectLiveDropdown from "../../../../../components/MultiSelectLiveDropdown/MultiSelectLiveDropdown";
import Popup from "../../../../../components/Popup/Popup";
import translate from "../../../../../services/Translate";
import { addUsersToAttendance } from "../ManageMeeting.function";
import { UsersAttendancePopupProps } from "./UsersAttendancePopup.d";

const UsersAttendancePopup = ({
  meetingId,
  language,
  openAddUsersModal,
  setOpenAddUsersModal,
  refreshMeeting,
}: UsersAttendancePopupProps) => {
  const [usersToAdd, setUsersToAdd] = useState<number[]>([]);
  const [isAdding, setIsAdding] = useState(false);

  return (
    <Popup
      show={openAddUsersModal}
      onClose={() => setOpenAddUsersModal(false)}
      modalTitle={translate(language, "PAGES.MEETING.MANAGE_MEETING.ATTENDANCE.POPUP.USERS.TITLE")}
    >
      <div className="d-flex flex-column">
        <div className="flex-grow-1">
          <MultiSelectLiveDropdown
            category={["users"]}
            label={
              usersToAdd && usersToAdd.length > 0
                ? `${usersToAdd.length} ${translate(
                    language,
                    "PAGES.MEETING.MANAGE_MEETING.ATTENDANCE.POPUP.USERS.SELECTED"
                  )}`
                : translate(language, "PAGES.MEETING.MANAGE_MEETING.ATTENDANCE.POPUP.USERS.PLACEHOLDER")
            }
            language={language}
            mockClass="rounded-0 rounded-end"
            toggleClass="min-w-100px m-regular"
            onConfirm={(selectedUsers: any[]) => setUsersToAdd(selectedUsers.map((user) => user.value.id))}
            showFilterButton={false}
            clearItemsOnSend={false}
          />
        </div>
        <div className="d-flex justify-content-end mt-4">
          <DstButton
            btnWidth="100px"
            variant="primary"
            value={translate(language, "PAGES.MEETING.MANAGE_MEETING.ATTENDANCE.POPUP.ADD_BUTTON")}
            clickFunction={() => {
              setIsAdding(true);
              addUsersToAttendance(
                meetingId,
                usersToAdd,
                language,
                () => {
                  setOpenAddUsersModal(false);
                  setUsersToAdd([]);
                  refreshMeeting();
                },
                () => {
                  setIsAdding(false);
                }
              );
            }}
            btnClass="me-2"
            loading={isAdding}
          />
        </div>
      </div>
    </Popup>
  );
};

export default UsersAttendancePopup;
